export default "__VITE_ASSET__DdQLjaKI__"